import React from 'react';
import { Instagram as InstagramIcon, Facebook } from 'lucide-react';
import { Button } from './ui/button';

export const Instagram = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Follow <span className="text-[#0B7CB5]">Our Journey</span>
            </h2>
            <p className="text-xl text-gray-600">
              Get cleaning tips, behind-the-scenes, and transformations — connect with us on social media!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Instagram */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200 rounded-2xl p-12 text-center hover:shadow-lg transition-shadow duration-300">
              <InstagramIcon className="w-16 h-16 text-purple-600 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Instagram</h3>
              <p className="text-gray-600 mb-6">@custommaidsrva</p>
              <a
                href="https://www.instagram.com/custommaidsrva"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors h-9 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white"
                style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 50 }}
              >
                <InstagramIcon className="mr-2 w-5 h-5" />
                Follow on Instagram
              </a>
            </div>

            {/* Facebook */}
            <div className="bg-gradient-to-br from-blue-50 to-[#0B7CB5]/10 border-2 border-[#0B7CB5]/30 rounded-2xl p-12 text-center hover:shadow-lg transition-shadow duration-300">
              <Facebook className="w-16 h-16 text-[#0B7CB5] mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Facebook</h3>
              <p className="text-gray-600 mb-6">@custommaidsrva</p>
              <a
                href="https://www.facebook.com/custommaidsrva"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors h-9 px-4 py-2 bg-[#0B7CB5] hover:bg-[#095a87] text-white"
                style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 50 }}
              >
                <Facebook className="mr-2 w-5 h-5" />
                Follow on Facebook
              </a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 text-lg">
              See our latest projects, cleaning tips, and client testimonials!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};